export enum SelectionLimitBehavior {
  PREVENT_SELECTION = 'PREVENT_SELECTION',
  DESELECT_FIRST = 'DESELECT_FIRST',
  ALLOW_OVER_LIMIT = 'ALLOW_OVER_LIMIT',
}

export interface DesignPageSelectorOpts {
  pageLimit?: number;
  onPageLimitExceeded?: VoidFunction;
  enforceAtLeastOneSelection?: boolean;
  selectionLimitBehavior?: SelectionLimitBehavior;

  /**
   * If `selectionLimitBehavior` is `PREVENT_SELECTION`, disables all unselected pages once the limit is reached.
   */
  disableRemainingOnPreventSelection?: boolean;
}

export enum PageSelectorSize {
  SMALL,
  MEDIUM,
}

export interface GetPagePreviewsForPosterResponse {
  pageIds: string[];
  previewUrls: Record<string, string>;
}
